/* SBTC UI — travelling selection border for card grids.
 *
 * Click a card and the gold border animates from wherever it was to that card.
 * Works on the birthday, private-events and membership grids without any
 * per-section wiring: it finds the grids by class and enhances what it finds.
 *
 * Progressive enhancement. If this file fails to load, the markup still renders
 * a statically bordered "most popular" card and every CTA still works, so
 * nothing is gated behind JS.
 */
(function () {
  'use strict';

  var GRIDS = ['.bd-grid', '.pv-grid', '.mb-tiers'];
  var CARDS = '.bd-pkg, .pv-pkg, .mb-tier';

  function enhance(grid) {
    var cards = Array.prototype.filter.call(grid.children, function (el) {
      return el.matches && el.matches(CARDS);
    });
    if (cards.length < 2) return;

    grid.classList.add('sbtc-selgrid');

    var sel = document.createElement('span');
    sel.className = 'sbtc-sel';
    sel.setAttribute('aria-hidden', 'true');
    grid.insertBefore(sel, grid.firstChild);

    // Start on whichever card the section already marked, else the first.
    var current =
      grid.querySelector('.bd-pkg--pick, .pv-pkg--pick, .mb-tier--pick') || cards[0];

    function place(card, animate) {
      if (!animate) sel.style.transition = 'none';
      // offsetLeft/Top are relative to the grid because it is position:relative.
      sel.style.width = card.offsetWidth + 'px';
      sel.style.height = card.offsetHeight + 'px';
      sel.style.transform =
        'translate3d(' + card.offsetLeft + 'px,' + card.offsetTop + 'px,0)';
      // Match the card's own corner radius so the border traces its real edge.
      var r = window.getComputedStyle(card).borderRadius;
      if (r) sel.style.borderRadius = r;
      if (!animate) {
        // Force a reflow so the suppressed transition cannot batch with the next change.
        void sel.offsetWidth;
        sel.style.transition = '';
      }
    }

    function select(card, animate) {
      if (!card) return;
      // Gold stays reserved for the featured card; everything else selects green.
      var featured = card.matches('.bd-pkg--pick, .pv-pkg--pick, .mb-tier--pick');
      sel.classList.toggle('sbtc-sel--alt', !featured);
      cards.forEach(function (c) {
        var on = c === card;
        c.classList.toggle('is-selected', on);
        if (on) c.setAttribute('aria-current', 'true');
        else c.removeAttribute('aria-current');
      });
      current = card;
      place(card, animate);
    }

    cards.forEach(function (card) {
      if (!card.hasAttribute('tabindex')) card.setAttribute('tabindex', '0');

      card.addEventListener('click', function (e) {
        // Never swallow a real CTA. Links and buttons keep their own behaviour.
        if (e.target.closest('a, button')) return;
        select(card, true);
      });

      card.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
        if (e.target.closest('a, button')) return;
        e.preventDefault();
        select(card, true);
      });
    });

    select(current, false);
    // Reveal synchronously. requestAnimationFrame does not fire in a background
    // tab, so gating visibility on it leaves the border invisible until the tab
    // is focused. The first placement already ran with transitions suppressed,
    // so there is no flash to guard against.
    sel.classList.add('is-ready');

    // Reposition on resize; the grid collapses to 2-up then 1-up at breakpoints.
    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(function () { place(current, false); }, 120);
    }, { passive: true });

    // Cards can grow after webfonts land, which would leave the border short.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { place(current, false); });
    }
  }

  function init() {
    var found = false;
    GRIDS.forEach(function (q) {
      Array.prototype.forEach.call(document.querySelectorAll(q), function (g) {
        enhance(g);
        found = true;
      });
    });
    if (found) document.documentElement.classList.add('js-sbtc-select');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
